import PropTypes from 'prop-types'

import { FieldSelectComponent } from '../FieldSelect'

import './index.css'

const TabsComponent = ({ value, options, config={}, events={} }) => {
    if (value === undefined || !options)
        return

    const handleChange = (index) => {
        if (events.handleChange)
            events.handleChange(index)
    }

    const getTabs = () => {
        return options.map((item, index) => {
            return (
                <div className={`tab ${index === value ? 'active' : ''}`} key={JSON.stringify(item)} onClick={() => handleChange(index)}>
                    {item.title}
                </div>
            )
        })
    }

    // narrow layouts don't have room for the full tab strip — both are
    // always mounted, CSS alone (not a JS width measurement) decides
    // which one is visible, same reasoning as the list-header sticky
    // offset: nothing here depends on ResizeObserver/matchMedia ever firing
    return (
        <div className={`c-Tabs type-${config.type || 'compact'}`}>
            <div className="tabs-strip">
                {getTabs()}
            </div>

            <div className="tabs-mobileSelect">
                <FieldSelectComponent
                    value={value}
                    config={{
                        label: 'Viewing',
                        size: 'small',
                        options: options.map((item, index) => ({ value: index, label: item.title }))
                    }}
                    events={{ handleChange }}
                />
            </div>
        </div>
    )
}

TabsComponent.propTypes = {
    value: PropTypes.number,

    options: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.any
    })),

    config: PropTypes.shape({
        type: PropTypes.oneOf(['compact', 'simple'])
    }),

    events: PropTypes.shape({
        handleChange: PropTypes.func
    })
}

export { TabsComponent }